import { internalsName } from "@gr-common/async/errors";
import { TimeoutError as TimeoutErrorClass } from "../lib/errors/timeout";
import { AbortError as AbortErrorClass } from "../lib/errors/abort";
import { RequestError as RequestErrorClass } from "../lib/errors/request";
function getInternals() {
  if (import.meta.env.SSR) {
    return {
      errors: {
        AbortError: AbortErrorClass,
        TimeoutError: TimeoutErrorClass,
        RequestError: RequestErrorClass
      }
    };
  }
  const res = Object.getOwnPropertySymbols(window).find((s) => {
    return s.description === internalsName;
  });
  return window[res] ?? {};
}
const { AbortError, TimeoutError, RequestError } = getInternals().errors ?? {};
export {
  AbortError,
  RequestError,
  TimeoutError
};
